import FirmSettingsPage from "@landingClient/pages/firmSettings/FirmSettings";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/firm-settings/")({
  component: FirmSettingsPage,
});
